
export default function ProductDescription() {
  const kitItems = [
    {
      icon: 'ri-knife-blood-line',
      name: 'Faca Cutelo 8" - 32cm',
      description: 'Ideal para cortar ossos e carnes mais duras'
    },
    {
      icon: 'ri-knife-line',
      name: 'Faca de chefe 8" - 32cm',
      description: 'Ideal para cortes precisos e preparo geral'
    },
    {
      icon: 'ri-knife-blood-line',
      name: 'Faca de trinchar 8" - 31,5cm',
      description: 'Perfeita para trinchar carnes e aves'
    },
    {
      icon: 'ri-knife-line',
      name: 'Faca de descascar 3,5" - 21cm',
      description: 'Ideal para descascar frutas e legumes pequenos'
    },
    {
      icon: 'ri-scissors-cut-line',
      name: 'Tesoura multifuncional de cozinha',
      description: 'Versátil para diversas tarefas culinárias'
    },
    {
      icon: 'ri-apple-line',
      name: 'Descascador de Frutas e Legumes',
      description: 'Ferramenta prática para descascar com facilidade'
    }
  ];

  return (
    <section className="py-16 bg-white">
      <div className="container mx-auto px-4">
        {/* Seção descritiva sobre o Kit */}
        <div className="text-center mb-16">
          <h2 className="text-3xl lg:text-4xl font-bold text-gray-800 mb-8">
            O Kit de Facas Mais Amado pelos Chefes
          </h2>
          <div className="max-w-4xl mx-auto">
            <p className="text-lg text-gray-700 leading-relaxed mb-6">
              Descubra por que nosso <strong>Kit de Facas Profissional</strong> é considerado o melhor e mais amado pelos chefes de cozinha profissionais e entusiastas culinários. Fabricado com <strong>aço inoxidável de alta resistência</strong> e durabilidade excepcional, cada faca possui um <strong>revestimento antiaderente</strong> que facilita os cortes mais precisos e suaves.
            </p>
            <p className="text-lg text-gray-700 leading-relaxed mb-6">
              Este é o <strong>kit perfeito e completo</strong>, contendo todas as peças essenciais que uma pessoa precisa na cozinha. Seja para o preparo diário de alimentos ou para aquele churrasco especial, nosso kit se tornou o <strong>preferido de todos os dias</strong> por sua versatilidade, qualidade superior e design ergonômico.
            </p>
            <p className="text-lg text-gray-700 leading-relaxed">
              Com tecnologia avançada e materiais premium, cada faca mantém o fio por muito mais tempo, proporcionando cortes eficientes e seguros. É a escolha inteligente para quem busca <strong>qualidade profissional</strong> na sua cozinha.
            </p>
          </div>
        </div>

        <div className="text-center mb-12">
          <h3 className="text-3xl lg:text-4xl font-bold text-gray-800 mb-8">
            O que você recebe no KIT
          </h3>
          
          {/* Imagem quadrada 1080x1080 */}
          <div className="mb-12 flex justify-center">
            <div className="w-80 h-80 rounded-lg overflow-hidden">
              <img 
                src="https://static.readdy.ai/image/32da3dbc6c077a42865d0d012e77efdf/6f67d25c335a63e0e6ec19454b325ae5.png"
                alt="Kit Completo de Facas Profissionais"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
        
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {kitItems.map((item, index) => (
            <div key={index} className="bg-gray-50 rounded-lg p-6 hover:shadow-lg transition-shadow duration-300">
              <div className="w-12 h-12 bg-red-100 rounded-lg flex items-center justify-center mb-4">
                <i className={`${item.icon} text-2xl text-red-600`}></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-800 mb-2">
                {item.name}
              </h3>
              <p className="text-gray-600">
                {item.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
